import React, { useEffect, useRef, useState } from 'react';
import { Box, CircularProgress, FormControlLabel, Switch, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import getStateManager from '../../StateManager';
import { InfoButton } from '../../FormWidgets/Description';

let nextRequest = 0;

// The server owns the persisted controller preference. A sent request is not a
// saved setting; retain the last acknowledged value until its reply arrives.
export default function RecordingControl({ controller, response }) {
  const { t } = useTranslation();
  const [recording, setRecording] = useState(null);
  const [pending, setPending] = useState(null);
  const [status, setStatus] = useState(null);
  const timeout = useRef(null);
  useEffect(() => () => clearTimeout(timeout.current), []);
  useEffect(() => {
    if (response?.recording) setRecording(response.recording);
    if (!pending || response?.request_id !== pending) return;
    clearTimeout(timeout.current);
    setPending(null);
    setStatus(response.status === 'ok' ? null : response.status);
  }, [response, pending]);
  const change = (enabled) => {
    const requestId = `recording-${Date.now()}-${++nextRequest}`;
    setPending(requestId);
    setStatus(null);
    timeout.current = setTimeout(() => { setPending(null); setStatus('timeout'); }, 10000);
    try {
      if (getStateManager().wsManager.sendWSMsg(controller, 'request_database_logging',
        { request_id: requestId, view: 'recording', enabled }, true, false, true)) return;
    } catch (_) { /* Keep the confirmed value when transport fails. */ }
    clearTimeout(timeout.current);
    setPending(null);
    setStatus('offline');
  };
  return <Box mt={1}>
    <Box display="flex" alignItems="center" flexWrap="wrap">
      <FormControlLabel label={t('database_recording_enabled')} control={<Switch color="primary"
        checked={Boolean(recording?.enabled)} disabled={!recording?.available || Boolean(pending)}
        onChange={(_, enabled) => change(enabled)} />} />
      {pending && <CircularProgress size={18} aria-label={t('loading')} />}
      <InfoButton brief={t('database_recording_enabled')} content={t('database_recording_help')} />
    </Box>
    {recording && !recording.available && <Typography variant="caption" color="textSecondary">{t('database_recording_server_disabled')}</Typography>}
    {status && <Typography variant="caption" color="error">{t('database_status_' + status)}</Typography>}
  </Box>;
}
